import { render, staticRenderFns } from "./Transportadora.vue?vue&type=template&id=8f099506"
import script from "./Transportadora.vue?vue&type=script&lang=js"
export * from "./Transportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports